// 缓存工具类 cacheUtils.js
const CACHE_PREFIX = 'myApp_'; // 缓存键名前缀（避免与其他应用冲突）

export default {
  /**
   * 设置缓存（默认5分钟过期）
   * @param {string} key 缓存键
   * @param {any} value 缓存值（自动JSON序列化）
   * @param {number} expireMinutes 过期时间（分钟，默认5）
   */
  set(key, value, expireMinutes = 5) {
    try {
      const data = {
        value, // 实际存储的值
        expire: Date.now() + expireMinutes * 60 * 1000 // 过期时间戳
      };
      localStorage.setItem(CACHE_PREFIX + key, JSON.stringify(data));
    } catch (error) {
      console.error('缓存设置失败:', error);
    }
  },

  /**
   * 获取缓存（自动处理过期）
   * @param {string} key 缓存键
   * @returns {any|null} 未过期时返回解析后的值，否则返回null
   */
  get(key) {
    try {
      const cachedData = localStorage.getItem(CACHE_PREFIX + key);
      if (!cachedData) return null;

      const parsedData = JSON.parse(cachedData);
      if (Date.now() > parsedData.expire) {
        this.remove(key); // 已过期则删除
        return null;
      }
      return parsedData.value;
    } catch (error) {
      console.error('缓存读取失败:', error);
      this.remove(key); // 数据异常时清除
      return null;
    }
  },

  /** 删除指定缓存 */
  remove(key) {
    localStorage.removeItem(CACHE_PREFIX + key);
  },

  /** 清空所有本应用缓存 */
  clear() {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith(CACHE_PREFIX)) {
        localStorage.removeItem(key);
      }
    });
  }
};